var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isIcon)?_c('v-icon',{attrs:{"loading":_vm.loading,"color":"red"},on:{"click":_vm.exportPdf}},[_vm._v("mdi-file-pdf-box")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }